/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取我的印花记录
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class MyPrintingRecordParams {
  constructor(public activityId: string) {}
}

export default async function (
  params: MyPrintingRecordParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<member.GetMyPrintingRecordResponse>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/myPrintingRecord`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
